import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { useI18n, type MessageKey } from "../i18n";
import "../pages/storage.css";

const IS_NATIVE = import.meta.env.VITE_CLIENT === "native";

/**
 * Task MM: owner dashboard banner when file storage reaches 80 % / 95 % / full. Existing files, POS and checkout
 * always keep working; above the 5 % grace only new uploads stop. The fix link (Settings → 存储空间, where storage
 * is bought) exists on the web owner portal only — never in the store apps.
 */
export function StorageBanner({ ws }: { ws: string }) {
  const { me } = useAuth();
  const { t } = useI18n();
  const s = me?.storage;
  if (!s || s.level === 0 || ws !== "owner") return null;
  const text = s.blocked ? t("mm.banner.blocked" as MessageKey) : t(("mm.banner." + s.level) as MessageKey, { pct: Math.floor(s.pct) });
  return (
    <div className={"banner storage-banner " + (s.level >= 95 ? "banner-error" : "banner-warn")} role="status" data-testid="storage-banner" data-level={s.level}>
      <span>{text}</span>
      {!IS_NATIVE && <Link className="btn btn-sm btn-soft" to={IS_NATIVE ? "/" : "/owner/settings?tab=storage"}>{t("mm.banner.fix" as MessageKey)}</Link>}
    </div>
  );
}
